import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/home.vue')
  },
  {
    path: '/main/:apartmentId',
    name: 'Main',
    component: () => import('../views/main.vue')
  },
  {
    path: '/landing/:apartmentId',
    name: 'Landing',
    component: () => import('../views/landing.vue')
  },
  {
    path: '/apartment-register/:apartmentId',
    name: 'ApartmentRegister',
    component: () => import('../views/apartment-register.vue')
  },
  {
    path: '/apartment-faq/:apartmentId',
    name: 'ApartmentFAQ',
    component: () => import('../views/apartment-faq.vue')
  },
  {
    path: '/leads/:apartmentId',
    name: 'Leads',
    component: () => import('../views/leads.vue')
  },
  {
    path: '/error',
    name: 'Error',
    component: () => import('../views/error.vue')
  },
  {
    path: '/confirm/:leadId',
    name: 'Confirm',
    component: () => import('../views/confirm.vue')
  },
  { path: "*", name: 'PageNotFound', component: () => import('../views/notfound.vue') }
]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
